export default __webpack_public_path__ + "static/media/rtth99ngv4261.f9b7b757.png";